import { useEffect } from 'react';
import useMobxStores from './useMobxStores';

/**
 * Registers or unregisters a reason to hide the Intercom widget based on a condition.
 * Use this in any component that should hide Intercom while active (e.g. AI assistant sidebar, modal).
 *
 * @param reasonId - Unique id for this hide reason (e.g. 'course:ai-assistant'). Must be stable.
 * @param shouldHide - When true, Intercom is hidden; when false, this reason is cleared.
 */
export default function useIntercomHideReason(
  reasonId: string,
  shouldHide: boolean,
): void {
  const { uiStore } = useMobxStores();

  useEffect(() => {
    if (shouldHide) {
      uiStore.registerIntercomHideReason(reasonId);
    } else {
      uiStore.unregisterIntercomHideReason(reasonId);
    }
    return () => {
      uiStore.unregisterIntercomHideReason(reasonId);
    };
  }, [reasonId, shouldHide, uiStore]);
}
